
import { Vue, Options } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useStore } from '@/store'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponLotus, modalOptionsCouponBZB } from '@/model/modal-options.model'
import liff from '@line/liff'
import { mapState } from 'vuex'
import { Watch } from 'vue-property-decorator'
import { getEventPostMessage } from '@/helpers/eventPostMessage'
import { MyCoupon, MyCouponType } from '@/model/my-coupon.model'
import { MyCouponInfoPayload } from '@/interfaces/store/myCouponInfo'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'

library.add(faChevronLeft)

@Options({
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState({
      isModalIframeActive: (state: any) => state.modalIframe.isModalIframeActive,
      modalOptionsIframe: (state: any) => state.modalIframe.modalOptionsIframe,
    }),
    modalOptions() {
      this.$store.dispatch('connectivity/checkOnlineStatus')
      return this.$store.state.modalIframe.modalOptionsIframe
    }
  }
})
export default class ModalIframe extends Vue {
  store = useStore()
  isOpenned = this.store.state.modalIframe.isModalIframeActive
  userToken = ''
  iFrameUrl: string = this.getIframeUrl()
  isIFrameReady = false
  showIframe = true
  isOfferUrl = false
  iFrameName = MyCoupon.IFRAME_NAME
  isSearchOfferSpecial = false
  viewportHeight = 0

  @Watch('isModalIframeActive')
  onChangeModalIframeActive(value: boolean) {
    this.isOpenned = value
    this.showIframe = value
  }

  @Watch('modalOptionsIframe')
  onChangeModalOptionsIframe() {
    this.iFrameUrl = this.getIframeUrl()
  }

  @Watch('showIframe')
  onChangeShowIframe() {
    this.iFrameUrl = this.getIframeUrl()
    this.store.dispatch('connectivity/checkOnlineStatus')
  }

  async created() {
    if (window) {
      window.addEventListener('message', this.handleIframeEvent)
    }

    await this.refreshUserToken()
  }

  async unmounted() {
    if (window) {
      window.removeEventListener('message', this.handleIframeEvent)
    }
  }

  updateStoredPoints(points: number) {
    const customer = this.store.state.customer
    customer.points = points
    this.store.commit('customer/updateCustomer', customer)
  }

  setIsLoadingPoints (value: boolean) {
    this.store.commit('app/setIsLoadingPoints', value)
  }

  async pointsRefresh() {
    let result
    const idToken = this.store.state.lineInfo.idToken  
    
    if (idToken) {
      this.setIsLoadingPoints(true)
      result = await meService.getCustomerInfo(idToken, ['points'])
    }
    
    if (result?.httpStatusCode === 200) {
      const { points } = result.json.data
      this.updateStoredPoints(points)
      this.setIsLoadingPoints(false)
    } else if (result?.httpStatusCode === 401) {
      this.setIsLoadingPoints(false)
      liff.logout()
      liff.login()
    }
  }

  async handleIframeEvent(event: MessageEvent) {
    console.log('Received message from iframe:', event.data)
    if (event.data === 'reload-page') {
      location.reload()
    }
    if (event.data === 'request-new-token') {
      this.getUserTokenAndResponseByEvent()
    } else if (event.data === 'refresh-token') {
      await this.refreshUserToken()
      this.iFrameUrl = this.getIframeUrl()
    } else if (event.data === 'iframe:ready') {
      this.isIFrameReady = true
    } else if (event.data === 'parent:navigate_back') {
      this.pointsRefresh()
      this.couponsSpecialForYouRefresh()
      this.offersVoucherRefresh()
      this.offersPremiumRefresh()
      this.offersSpecialStoreRefresh()
      this.actionCloseModal()
    } else if (event.data?.topic === 'open-lotuss-app') {
      const query = this.$route?.query
      if(query['is_disabled_deeplink'] !== 'true') {
        liff.openWindow({ url: event.data?.url })
      }  
    }
    if (event.data === 'back-to-offers-list') {
      const customerType = this.store.state.customer?.customerType ?? undefined
      const socialToken = this.store.state.lineInfo?.socialToken ?? undefined
      modalOptionsCouponBZB.url = getUrlModalOptionsMyCoupon(undefined, 'lifestyle', 'offer', undefined, customerType, socialToken)
      this.store.commit('modalIframe/updateModalIframeActive', true)
      this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponBZB)
    }
    if (event.data === 'back-to-coupons-list') {
      const customerType = this.store.state.customer?.customerType ?? undefined
      modalOptionsCouponLotus.url = getUrlModalOptionsMyCoupon(undefined, 'lotus', 'offer', undefined, customerType, undefined)
      this.store.commit('modalIframe/updateModalIframeActive', true)
      this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponLotus)
    }
    if (event.data === 'popstate') {
      liff.closeWindow()
    }
    if (event.data?.topic === 'add-ga-event') {
      addGAEvent(event.data?.event)
    }
    if (event.data === 'request-bzb-token') {
      await this.fetchBZBToken()
    }
    if (event.data === 'bzb-token-error') {
      console.log('Get event: bzb-token-error')
    }
    if (event.data === 'search-offer-special') {
      const data = { ...modalOptionsCouponBZB, title: 'ค้นหา' }

      this.isSearchOfferSpecial = true
      this.store.commit('modalIframe/updateModalOptionsIframe', data)
    }
    if (
      event.data === 'go-to-offer-special-details' ||
      event.data === 'selected-offer-special-list' ||
      event.data === 'selected-offer-list'
    ) {
      this.isSearchOfferSpecial = false
      this.store.commit('modalIframe/updateModalOptionsIframe', modalOptionsCouponBZB)
    }
  }

  async fetchBZBToken () {
    try {
      const idToken = liff.getIDToken()
      const socialToken = liff.getAccessToken()

      if (idToken && socialToken) {
        const result =  await meService.getBZBToken(idToken, socialToken)

        if (result && window && this.isIFrameReady) {
          const token = result.json.data.bzb_token
    
          getEventPostMessage(
            document.getElementsByName(this.iFrameName), 
            JSON.stringify({ type: 'bzb-token-received', token }), 
            this.iFrameName
          )
        }
      }
    } catch (e) {
      getEventPostMessage(
        document.getElementsByName(this.iFrameName), 
        JSON.stringify({ type: 'bzb-token-received', token: null }), 
        this.iFrameName
      )
    }
  }
  async couponsSpecialForYouRefresh() {
    this.store.commit('myCouponInfo/updateCouponsIsLoading', true)
    const token = this.store.state.lineInfo.idToken
    const tierType = this.store.state.tier?.tierName?.toLocaleLowerCase()
    const couponType = `${tierType === 'gold' ? 'Gold' : ''}${MyCouponType.SPECIAL_FOR_YOU}`
    await this.store.dispatch('myCouponInfo/fetchCouponsList', { token, couponType } as MyCouponInfoPayload)
  }

  async offersVoucherRefresh() {
    this.store.commit('myCouponInfo/updateVoucherOffersIsLoading', true)
    const token = this.store.state.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchVoucherOffersList', { token } as MyCouponInfoPayload)
  }

  async offersPremiumRefresh() {
    this.store.commit('myCouponInfo/updatePremiumOffersIsLoading', true)
    const token = this.store.state.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchPremiumOffersList', { token } as MyCouponInfoPayload)
  }

  async offersSpecialStoreRefresh() {
    this.store.commit('myCouponInfo/updatePartnerOffersIsLoading', true)
    const token = this.store.state.lineInfo.idToken
    await this.store.dispatch('myCouponInfo/fetchPartnerOffersList', { token } as MyCouponInfoPayload)
  }

  actionCloseModal() {
    this.isIFrameReady = false
    window.history.replaceState(null, '', '/')
    this.store.commit('modalIframe/updateModalIframeActive', false)
  }

  closeModal() {
    if (window && this.isIFrameReady) {
      getEventPostMessage(document.getElementsByName(this.iFrameName), 'iframe:navigate_back', this.iFrameName)
    } else {
      this.actionCloseModal()
    }
  }

  getIframeUrl() {
    const modalOptionsIframe = this.store.state.modalIframe.modalOptionsIframe

    if (!modalOptionsIframe?.url) {
      return ''
    }
    
    if(this.isSearchOfferSpecial) {
      this.isOfferUrl = false
      this.isSearchOfferSpecial = false
    } else {
      this.isOfferUrl = modalOptionsIframe.url.includes('offers')
    }

    return `${modalOptionsIframe.url}&token=${this.store.state.lineInfo.idToken}`
  }

  sleep(ms: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, ms)
    })
  }

  async waitForLineIdToken() {
    let isLooping = true
    while (isLooping) {
      if (this.store.state.lineInfo.idToken) {
        isLooping = false
        break
      }
      await this.sleep(10)
    }
  }

  async getUserTokenAndResponseByEvent() {
    let lineIdToken = this.store.state.lineInfo.idToken
    console.log({
      lineIdToken
    })
    if (!lineIdToken) {
      await this.waitForLineIdToken()
      lineIdToken = this.store.state.lineInfo.idToken
    }
    const result = await meService.getToken(lineIdToken!)
    if (result.httpStatusCode === 200) {
      const { token: myCouponToken } = result.json.data
      console.log({
        myCouponToken
      })
      getEventPostMessage(
        document.getElementsByName(this.iFrameName), 
        { command: 'new-token-received', value: myCouponToken }, 
        this.iFrameName
      )
    }
  }

  async refreshUserToken() {
    const token = this.store.state.myCouponInfo.token
    this.userToken = `&token=${token}`
  }
}
